import { isNumber } from 'lodash';
import { defaultContur, conturs } from '../../../../translations';

// Функция для форматирования числа с разделением тысяч
export const formatPrice = (price) => {
  if (!isNumber(price)) return price;

  const fixed = price.toFixed(2);
  const [integer, fraction] = fixed.split('.');

  if (defaultContur === conturs.me) {
    const formattedInteger = integer.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    return `${formattedInteger}.${fraction}`;
  }

  const formattedInteger = integer.replace(/\B(?=(\d{3})+(?!\d))/g, ' ');
  return fraction && parseInt(fraction, 10) !== 0 ? `${formattedInteger}.${fraction}` : formattedInteger;
};
